import BackboneElement from './BackboneElement';
import merge from 'lodash/merge';
import Reference from './types/Reference';
import Period from './types/Period';

export default class AccountGuarantor extends BackboneElement {
    static __className = 'AccountGuarantor';

    __objectStructure = {
        party: Reference,
        onHold: Boolean,
        period: Period,
    };

    constructor(constructJson, className = 'AccountGuarantor') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
